<template>
	<div class="left-page">
		<div class="input-div">
			<!-- <el-input v-model="input" placeholder="请输入搜索的内容" size="medium" prefix-icon="el-icon-search"
				clearable></el-input> -->
			<el-input v-model="value" :placeholder="$t('请输入搜索的内容')" size="medium" prefix-icon="el-icon-search" clearable
				@change="valueChange"></el-input>
		</div>

		<el-tabs class="tabs" v-model="tabs" @tab-click="handleClick">
			<el-tab-pane v-for="item in tabList" :label="item.name" :name="item.id" :key="item.id"></el-tab-pane>
		</el-tabs>

		<ul>
			<li class="cur-poi" v-for="item in tableData" :key="item.id" @click="changeCode(item.code)">
				<div>
					<i class="el-icon-star-on cur-poi" :style="{ color: item.selected == 1 ? '#f0c163' : '' }"
						@click.stop="recentOrder(item)"></i>
				</div>
				<div class="cscs">
					<img :src="item.image" class="asd-logo">
					<div class="c-sdwa">
						<div class="fghf">
							<span>{{ item.title }}</span>
							<img src="@/assets/img-pc/icon1.png" class="qklx-img">
						</div>
						<!-- <div class="qklx">Ethereum</div> -->
					</div>
				</div>
				<div class="dsd-right">
					<span class="dr-s">${{ item.price }}</span>
					<span class="dr-x" :class="[item.price_zf >= 0 ? 'green' : 'red']">{{ item.price_zf >= 0 ? '+' : ''
					}}{{ item.price_zf }}%</span>
				</div>
			</li>
		</ul>
	</div>
</template>
<script>
import { get, post } from '@/http/request'
import { getQueryParam } from '@/common/public.js';
export default {
	components: {},
	props: {
	},
	data() {
		return {
			tabs: '0',
			tabList: [],
			value: '',
			tableData: [],

			code: getQueryParam('code'),
		};
	},
	created() {
		get(this.$apis.getProductTypeList, { showLoading: false }).then(res => {
			if (res.code != 1) return
			this.tabList = res.data.map(item => {
				item.id = String(item.id)
				return item
			}) || []

			if (this.tabList.length > 0) {
				this.tabs = this.tabList[1].id
				this.getData()
			}
		})
	},
	watch: {
	},
	methods: {
		handleClick() {
			// console.log(val) 
			this.getData()
		},
		valueChange() {
			// console.log(val)
			this.getData()
		},
		getData() {
			get(this.$apis.getProductList, { type: this.tabs, title: this.value, showLoading: false }).then(res => {
				if (res.code != 1) return
				this.tableData = res.data
				//地址栏 未带参数 默认第一个
				if (!this.code && this.tableData.length > 0) {
					let code = this.tableData[0].code
					this.changeCode(code)
				}
			})
		},
		recentOrder(item) {
			post(this.$apis.operateUserProduct,
				{
					product_ids: item.id,
					type: item.selected == 0 ? 1 : 2
				}).then(res => {
					if (res.code == 1) {
						this.getData()
					}
				})
		},

		changeCode(code) {
			this.$emit('changeCode', code)
		}
	},
};
</script>
<style lang="scss" scoped>
.left-page {
	width: 300px;

	ul {
		list-style: none;
		max-height: 180vh;
		overflow: auto;
		/* 允许滚动 */
		scrollbar-width: none;
		/* Firefox */
		-ms-overflow-style: none;
		/* IE 10+ */

		li {
			display: flex;
			align-items: center;
			padding: 16px;

			.dsd-right {
				margin-left: auto;
				display: flex;
				flex-direction: column;
				align-items: flex-end;

				.dr-s {
					font-size: 14px;
					color: #fff;
				}


				.red {
					color: #ff4834 !important;
				}

				.green {
					color: #00f0ff !important;
				}
			}

			.cscs {
				display: flex;
				margin-left: 5px;
				align-items: center;

				.c-sdwa {
					display: flex;
					flex-direction: column;

					.fghf {
						font-size: 14px;
						color: #fff;
					}

					.qklx {
						color: #888;
						font-size: 12px;
						margin-top: 4px;
					}
				}

				.asd-logo {
					width: 24px;
					height: 24px;
					margin-right: 4px;
					border-radius: 50%;
					background-color: #000;
				}
			}
		}
	}

	.input-div {
		padding: 20px 30px 10px;
		color: #fff;
	}
}
</style>